export const init_crm_location = "/crm";
export const url_crm_dashboard = `${init_crm_location}/dashboard`;
export const url_crm_clients = `${init_crm_location}/clients`;
export const url_crm_contacts = `${init_crm_location}/contacts`;
export const url_crm_tasks = `${init_crm_location}/tasks`;
export const url_crm_quote = `${init_crm_location}/quote`;
export const url_crm_search = `${init_crm_location}/search`;
